const projectionCopy = {
  "es": {
    "Proyecciones": "Proyecciones",
    "Visualiza el futuro de tu negocio": "Visualiza el futuro de tu negocio",
    "Escenario de Proyección": "Escenario de Proyección",
    "Pesimista": "Pesimista",
    "Normal": "Normal",
    "Optimista": "Optimista",
    "Tasa de Crecimiento Promedio": "Tasa de Crecimiento Promedio",
    "Basado en los últimos 6 meses completos": "Basado en los últimos 6 meses completos",
    "Próximo mes · estimación": "Próximo mes · estimación",
    "Próximos 3 meses · estimación": "Próximos 3 meses · estimación",
    "Total acumulado, no un solo mes": "Total acumulado, no un solo mes",
    "Resto del año · estimación": "Resto del año · estimación",
    "{count} meses después del actual": "{count} meses después del actual",
    "Historial de ingresos": "Historial de ingresos",
    "Últimos seis meses completos; el mes en curso no se compara como si estuviera terminado.": "Últimos seis meses completos; el mes en curso no se compara como si estuviera terminado.",
    "Ingreso registrado": "Ingreso registrado",
    "Ingresos estimados por mes": "Ingresos estimados por mes",
    "Estimaciones desde el próximo mes según el escenario elegido. Los importes no son ingresos registrados.": "Estimaciones desde el próximo mes según el escenario elegido. Los importes no son ingresos registrados.",
    "Ingreso estimado": "Ingreso estimado",
    "Nota sobre las proyecciones": "Nota sobre las proyecciones",
    "Las proyecciones se basan en tu historial de ventas y no garantizan resultados futuros. Factores externos como estacionalidad, economía y competencia pueden afectar los resultados reales.": "Las proyecciones se basan en tu historial de ventas y no garantizan resultados futuros. Factores externos como estacionalidad, economía y competencia pueden afectar los resultados reales.",
    "Mes": "Mes",
    "Ingresos": "Ingresos",
    "Gastos": "Gastos",
    "Balance": "Balance",
    "Próximo Mes": "Próximo Mes",
    "Próximo Trimestre": "Próximo Trimestre",
    "Resto del Año": "Resto del Año",
    "Escenario": "Escenario",
    "Estimación": "Estimación",
    "Datos insuficientes": "Datos insuficientes",
    "Estado de la estimación": "Estado de la estimación",
    "proyecciones": "proyecciones"
  },
  "en": {
    "Proyecciones": "Projections",
    "Visualiza el futuro de tu negocio": "Visualize the Future of Your Business",
    "Escenario de Proyección": "Projection Scenario",
    "Pesimista": "Pessimistic",
    "Normal": "Normal",
    "Optimista": "Optimistic",
    "Tasa de Crecimiento Promedio": "Average Growth Rate",
    "Basado en los últimos 6 meses completos": "Based on the Last 6 Complete Months",
    "Próximo mes · estimación": "Next Month · Estimate",
    "Próximos 3 meses · estimación": "Next 3 Months · Estimate",
    "Total acumulado, no un solo mes": "Cumulative Total, Not a Single Month",
    "Resto del año · estimación": "Rest of the Year · Estimate",
    "{count} meses después del actual": "{count} months after the current month",
    "Historial de ingresos": "Income History",
    "Últimos seis meses completos; el mes en curso no se compara como si estuviera terminado.": "The last six complete months; the current month is not treated as complete.",
    "Ingreso registrado": "Recorded Income",
    "Ingresos estimados por mes": "Estimated Monthly Income",
    "Estimaciones desde el próximo mes según el escenario elegido. Los importes no son ingresos registrados.": "Estimates from next month based on the selected scenario. These amounts are not recorded income.",
    "Ingreso estimado": "Estimated Income",
    "Nota sobre las proyecciones": "Note About Projections",
    "Las proyecciones se basan en tu historial de ventas y no garantizan resultados futuros. Factores externos como estacionalidad, economía y competencia pueden afectar los resultados reales.": "Projections are based on your sales history and do not guarantee future results. External factors such as seasonality, the economy and competition may affect actual results.",
    "Mes": "Month",
    "Ingresos": "Income",
    "Gastos": "Expenses",
    "Balance": "Balance",
    "Próximo Mes": "Next Month",
    "Próximo Trimestre": "Next 3 Months",
    "Resto del Año": "Rest of the Year",
    "Escenario": "Scenario",
    "Estimación": "Estimate",
    "Datos insuficientes": "Insufficient Data",
    "Estado de la estimación": "Estimate Status",
    "proyecciones": "projections"
  },
  "pt": {
    "Proyecciones": "Projeções",
    "Visualiza el futuro de tu negocio": "Visualize o futuro do seu negócio",
    "Escenario de Proyección": "Cenário de projeção",
    "Pesimista": "Pessimista",
    "Normal": "Normal",
    "Optimista": "Otimista",
    "Tasa de Crecimiento Promedio": "Taxa média de crescimento",
    "Basado en los últimos 6 meses completos": "Com base nos últimos 6 meses completos",
    "Próximo mes · estimación": "Próximo mês · estimativa",
    "Próximos 3 meses · estimación": "Próximos 3 meses · estimativa",
    "Total acumulado, no un solo mes": "Total acumulado, não um único mês",
    "Resto del año · estimación": "Restante do ano · estimativa",
    "{count} meses después del actual": "{count} meses após o mês atual",
    "Historial de ingresos": "Histórico de receitas",
    "Últimos seis meses completos; el mes en curso no se compara como si estuviera terminado.": "Últimos seis meses completos; o mês atual não é tratado como concluído.",
    "Ingreso registrado": "Receita registrada",
    "Ingresos estimados por mes": "Receitas mensais estimadas",
    "Estimaciones desde el próximo mes según el escenario elegido. Los importes no son ingresos registrados.": "Estimativas a partir do próximo mês conforme o cenário escolhido. Os valores não são receitas registradas.",
    "Ingreso estimado": "Receita estimada",
    "Nota sobre las proyecciones": "Nota sobre as projeções",
    "Las proyecciones se basan en tu historial de ventas y no garantizan resultados futuros. Factores externos como estacionalidad, economía y competencia pueden afectar los resultados reales.": "As projeções se baseiam no seu histórico de vendas e não garantem resultados futuros. Fatores externos como sazonalidade, economia e concorrência podem afetar os resultados reais.",
    "Mes": "Mês",
    "Ingresos": "Receitas",
    "Gastos": "Despesas",
    "Balance": "Saldo",
    "Próximo Mes": "Próximo mês",
    "Próximo Trimestre": "Próximos 3 meses",
    "Resto del Año": "Restante do ano",
    "Escenario": "Cenário",
    "Estimación": "Estimativa",
    "Datos insuficientes": "Dados insuficientes",
    "Estado de la estimación": "Status da estimativa",
    "proyecciones": "projecoes"
  },
  "fr": {
    "Proyecciones": "Prévisions",
    "Visualiza el futuro de tu negocio": "Visualisez l’avenir de votre entreprise",
    "Escenario de Proyección": "Scénario de prévision",
    "Pesimista": "Pessimiste",
    "Normal": "Normal",
    "Optimista": "Optimiste",
    "Tasa de Crecimiento Promedio": "Taux de croissance moyen",
    "Basado en los últimos 6 meses completos": "Basé sur les 6 derniers mois complets",
    "Próximo mes · estimación": "Mois prochain · estimation",
    "Próximos 3 meses · estimación": "3 prochains mois · estimation",
    "Total acumulado, no un solo mes": "Total cumulé, pas un seul mois",
    "Resto del año · estimación": "Reste de l’année · estimation",
    "{count} meses después del actual": "{count} mois après le mois en cours",
    "Historial de ingresos": "Historique des revenus",
    "Últimos seis meses completos; el mes en curso no se compara como si estuviera terminado.": "Les six derniers mois complets ; le mois en cours n’est pas considéré comme terminé.",
    "Ingreso registrado": "Revenu enregistré",
    "Ingresos estimados por mes": "Revenus mensuels estimés",
    "Estimaciones desde el próximo mes según el escenario elegido. Los importes no son ingresos registrados.": "Estimations à partir du mois prochain selon le scénario choisi. Ces montants ne sont pas des revenus enregistrés.",
    "Ingreso estimado": "Revenu estimé",
    "Nota sobre las proyecciones": "Note sur les prévisions",
    "Las proyecciones se basan en tu historial de ventas y no garantizan resultados futuros. Factores externos como estacionalidad, economía y competencia pueden afectar los resultados reales.": "Les prévisions reposent sur votre historique de ventes et ne garantissent pas les résultats futurs. Des facteurs externes comme la saisonnalité, l’économie et la concurrence peuvent affecter les résultats réels.",
    "Mes": "Mois",
    "Ingresos": "Revenus",
    "Gastos": "Charges",
    "Balance": "Solde",
    "Próximo Mes": "Mois prochain",
    "Próximo Trimestre": "3 prochains mois",
    "Resto del Año": "Reste de l’année",
    "Escenario": "Scénario",
    "Estimación": "Estimation",
    "Datos insuficientes": "Données insuffisantes",
    "Estado de la estimación": "État de l’estimation",
    "proyecciones": "previsions"
  }
};
export default projectionCopy;
